import NiceModal, { useModal } from '@ebay/nice-modal-react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import Button from 'components/field/Button';

import LottiePlayer from './LottiePlayer';
import Modal from './Modal';
import * as S from './styled/ConfirmationModal.styled';

const ConfirmationModal = NiceModal.create(
	({
		title = 'leaveConfirmationTitle',
		subTitle = 'leaveConfirmationSubTitle',
		lottieName,
		yesAction,
		cancelAction,
		rejectLabel = 'no',
		confirmLabel = 'yes',
		lottieStyle,
		showCloseButton = false,
		maxWidth = 'x-small'
	}) => {
		const { t } = useTranslation();
		const modal = useModal();
		const handleCloseModal = () => {
			modal.remove();
		};

		return (
			<>
				<Modal maxWidth={maxWidth} fullwidth closeButton={showCloseButton} className="modal-confirmation">
					<S.Container>
						<S.IconContainer>
							<LottiePlayer name={lottieName ?? 'confirmation-modal'} style={lottieStyle} />
						</S.IconContainer>
						<S.HeadText>
							{typeof title === 'string' || title instanceof String ? t(title) : title}
						</S.HeadText>
						<S.BodyText>
							{typeof subTitle === 'string' || subTitle instanceof String ? t(subTitle) : subTitle}
						</S.BodyText>

						<S.BlockDiv>
							<S.ButtonContainer>
								<Button
									onClick={() => {
										handleCloseModal();
										cancelAction && cancelAction();
									}}
									label={t(rejectLabel)}
									variant="outline"
									style={{ minWidth: '70px' }}
								/>
							</S.ButtonContainer>
							<S.ButtonContainer>
								<Button
									onClick={() => {
										handleCloseModal();
										yesAction && yesAction();
									}}
									variant="blue"
									style={{ minWidth: '70px' }}
									label={confirmLabel}
								/>
							</S.ButtonContainer>
						</S.BlockDiv>
					</S.Container>
				</Modal>
			</>
		);
	}
);
ConfirmationModal.propTypes = {
	/** Title of the modal */
	title: PropTypes.string,
	/** Subtitle of the modal */
	subTitle: PropTypes.string,
	/** What to do  after clicking yes button */
	yesAction: PropTypes.func,
	/** What to do  after clicking cancel button */
	cancelAction: PropTypes.func,
	/** Name of the lottie animation */
	lottieName: PropTypes.string,
	/** Label of the cancel button */
	rejectLabel: PropTypes.string,
	/** Label of the confirm button */
	confirmLabel: PropTypes.string,
	/** Optional style object for lottie*/
	lottieStyle: PropTypes.object
};
export default ConfirmationModal;
